import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { ReferralsTermsCollectionHttpClient } from './terms-collection.http-client';
import { ReferralsTermsCollectionActions } from './terms-collection.store';

@Injectable({ providedIn: 'root' })
export class ReferralsTermsCollectionEffects {
  public effects = createEffectFactory(ReferralsTermsCollectionActions, this.actions$);

  public fetchCollection$ = this.effects(ReferralsTermsCollectionActions.fetchCollection, () =>
    this.http.loadTerms().pipe(map(data => ({ data }))),
  );

  public updateCollection$ = this.effects(
    ReferralsTermsCollectionActions.updateAll,
    ({ payload }) =>
      this.http.updateTerms(payload.terms).pipe(
        map(terms =>
          ReferralsTermsCollectionActions.updateAllSuccess({
            payload: { data: terms, scope: payload.scope },
          }),
        ),
        catchError(error =>
          of(
            ReferralsTermsCollectionActions.updateAllFailed({
              payload: { error, scope: payload.scope },
            }),
          ),
        ),
      ),
  );

  constructor(private actions$: Actions, private http: ReferralsTermsCollectionHttpClient) {}
}
